import AuthModule from '@/users/store/auth-module'

export default {
  AuthModule,
}
